import { useState } from "react";
import { api } from "../data/api";
import Btn from "../components/Btn";
import Logo from "../assets/logo.png";
import LoginBg from "../assets/login_screen.jpg";

export default function ResetPassword({ token, onDone }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm]   = useState("");
  const [error, setError]       = useState(null);
  const [success, setSuccess]   = useState(false);
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async () => {
    if (password.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }
    if (password !== confirm) {
      setError("Passwords don't match");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await api.auth.resetPassword(token, password);
      setSuccess(true);
    } catch (e) {
      setError(e.message || "Failed to reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--bg)",
        backgroundImage: `url(${LoginBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        paddingRight: "8%",
        fontFamily: "'DM Sans', system-ui, sans-serif",
      }}
    >
      <div
        style={{
          background: "var(--surface)",
          border: "1px solid var(--border)",
          borderRadius: 12,
          padding: "36px 32px",
          width: 380,
          boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 28 }}>
          <div style={{ width: 30, height: 30, borderRadius: 7, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <img style={{ width: 30, height: 30 }} src={Logo} alt="logo" />
            <span style={{ display: "flex", fontSize: 12, color: "var(--text)", fontWeight: 900 }}>DRPL</span>
          </div>
          <span style={{ fontSize: 17, fontWeight: 700, color: "var(--ink)", letterSpacing: "-0.01em" }}>
            SRT Manager
          </span>
        </div>

        {success ? (
          <>
            <div style={{ background: "var(--green-bg,#f0fdf4)", border: "1px solid var(--green-border,#86efac)", borderRadius: 6, padding: "10px 12px", marginBottom: 18, fontSize: 12, color: "var(--green,#16a34a)" }}>
              Your password has been updated. You can sign in now.
            </div>
            <Btn primary full onClick={onDone}>Go to Sign In</Btn>
          </>
        ) : (
          <>
            <div style={{ fontSize: 13, color: "var(--text-sub)", marginBottom: 16 }}>
              Set a new password for your account.
            </div>

            {error && (
              <div style={{ background: "var(--red-bg)", border: "1px solid var(--red-border)", borderRadius: 6, padding: "9px 12px", marginBottom: 16, fontSize: 12, color: "var(--red)" }}>
                {error}
              </div>
            )}

            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 5 }}>
                New Password
              </div>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="At least 8 characters"
                autoFocus
                style={{ width: "100%", background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 6, padding: "9px 11px", fontSize: 13, color: "var(--text)", fontFamily: "inherit", outline: "none", boxSizing: "border-box" }}
              />
            </div>

            <div style={{ marginBottom: 22 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 5 }}>
                Confirm Password
              </div>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") handleSubmit(); }}
                placeholder="Re-enter password"
                style={{ width: "100%", background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 6, padding: "9px 11px", fontSize: 13, color: "var(--text)", fontFamily: "inherit", outline: "none", boxSizing: "border-box" }}
              />
            </div>

            <Btn primary full disabled={loading} onClick={handleSubmit}>
              {loading ? "Saving…" : "Set New Password"}
            </Btn>
          </>
        )}
      </div>
    </div>
  );
}
